import React, { useState, useEffect } from 'react';
import axios from 'axios';
const Dashboard = () => {
  const [login, setlogin] = useState(false);
  const [msg, setMsg] = useState(false);
  const [email, setEmail] = useState('');
  const [data, setData] = useState([]);
  const [view, setView] = useState([]);
  const [mdata, setMData] = useState([]);
  const [password, setPassword] = useState('');

  const [category, setCategory] = useState('');
  const [image, setImage] = useState('');
  const [link, setLink] = useState('');

  const onsubLog = (e) => {
    e.preventDefault();

    if (
      email === 'atanuj625@gmail.com' &&
      password === '1atanuj625@gmail.com'
    ) {
      setlogin(true);
    } else {
      alert('Wrong Details');
      setlogin(false);
    }
  };

  const getdata = async () => {
    const res = await axios.get(
      'https://portfolio-node-7hlx.onrender.com/getallproject'
    );
    setData(res.data);
  };
  const getView = async () => {
    const res = await axios.get(
      'https://portfolio-node-7hlx.onrender.com/getViewers'
    );
    setView(res.data);
    console.log(res.data);
  };
  useEffect(() => {
    getdata();
    getView();
  }, []);

  const ShowHandel = async (id) => {
    const res = await axios.get(
      `https://portfolio-node-7hlx.onrender.com/updateproject/${id}`
    );
    getdata();
  };

  const AddNew = async (e) => {
    e.preventDefault();
    const data = {
      category,
      image,
      link,
    };
    const res = await axios.post(
      `https://portfolio-node-7hlx.onrender.com/postproject`,
      data
    );

    getdata();
  };
  const getData = () => {
    setMsg(false);
    getdata();
  };

  const getMsg = async () => {
    setMsg(true);
    const res = await axios.get(
      'https://portfolio-node-7hlx.onrender.com/getallcontact'
    );
    setMData(res.data);
  };

  return (
    <>
      {!login ? (
        <>
          <div className="login">
            <div className="loginbox">
              <h3 className="text-center">Admin Login</h3>
              <form onSubmit={onsubLog}>
                <div class="form-group">
                  <label>Email:</label>
                  <input
                    type="email"
                    class="form-control"
                    placeholder="Enter Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div class="form-group">
                  <label>Password:</label>
                  <input
                    type="password"
                    class="form-control"
                    placeholder="Enter Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>

                <div className="text-center">
                  <button type="submit" className="btn btn-dark ">
                    Login
                  </button>
                </div>
              </form>
            </div>
          </div>
        </>
      ) : (
        <div className="dashboard">
          <div className="container">
            <div className="row">
              <button
                className="btn btn-dark m-2"
                type="button"
                data-toggle="modal"
                data-target="#myModal"
              >
                Add New
              </button>
              <button className="btn btn-warning m-2" onClick={getMsg}>
                Show Message
              </button>
              {/* <button className="btn btn-warning m-2" onClick={getData}>All Project</button>
                       {
                           view? <button className="btn btn-success m-2">{
                            view[0].number 
                       }</button> : null
                       }  */}
            </div>
            <div class="modal" id="myModal">
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <h4 class="modal-title">Add New Project</h4>
                    <button type="button" class="close" data-dismiss="modal">
                      &times;
                    </button>
                  </div>

                  <div class="modal-body">
                    <form onSubmit={AddNew}>
                      <div class="form-group">
                        <label>Category:</label>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Enter Category"
                          value={category}
                          onChange={(e) => setCategory(e.target.value)}
                          required
                        />
                      </div>
                      <div class="form-group">
                        <label>Image Link:</label>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Enter Image link"
                          value={image}
                          onChange={(e) => setImage(e.target.value)}
                          required
                        />
                      </div>
                      <div class="form-group">
                        <label>Website Link:</label>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Enter Website Link"
                          value={link}
                          onChange={(e) => setLink(e.target.value)}
                          required
                        />
                      </div>
                      <div className="text-center">
                        <button type="submit" className="btn btn-dark ">
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            {msg ? (
              <div className="row">
                {mdata && (
                  <div class="table-responsive">
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Message</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {mdata?.map((val, ind) => {
                          return (
                            <>
                              <tr key={ind}>
                                <td>{val._id}</td>
                                <td>{val.name}</td>
                                <td>{val.email}</td>
                                <td>{val.message}</td>
                                <td>{new Date(val.date).toDateString()}</td>
                              </tr>
                            </>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            ) : (
              <div className="row">
                {data && (
                  <div class="table-responsive">
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Image</th>
                          <th>Link</th>
                          <th>Category</th>
                          <th>Operation</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.map((val, ind) => {
                          return (
                            <>
                              <tr key={ind}>
                                <td>{val._id}</td>
                                <td>
                                  <img
                                    src={val.image}
                                    alt="web"
                                    className="webimg"
                                  />
                                </td>
                                <td>{val.link}</td>
                                <td>{val.category}</td>
                                <td>
                                  {val.status ? (
                                    <button
                                      className="btn btn-danger"
                                      onClick={() => ShowHandel(val._id)}
                                    >
                                      Hide
                                    </button>
                                  ) : (
                                    <button
                                      className="btn btn-success"
                                      onClick={() => ShowHandel(val._id)}
                                    >
                                      Show
                                    </button>
                                  )}
                                </td>
                              </tr>
                            </>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Dashboard;
